export const Counter =(state = 0, action) => {
  switch (action.type) {
    case 'ADD_FRAMEWORK':
      console.log('redux hi')
      return state
    case 'INCREMENT':
      return state + 1
    case 'DECREMENT':
      return state - 1
    default:
      return state
  }
}
